import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof seoWidgetOpts === 'undefined' ? null : seoWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createCustomSeo(widgetData, $widget) {
  const $seo = $widget.find('.card-widget-item');
  const { Title, Description, URL, PurchaseURL } = widgetData[0];

  $seo.replaceWith(`
    <div class="text-section">
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
    </div>   
  `);

  if ((URL == null || URL === '') && (PurchaseURL == null || PurchaseURL === '')) {
    $widget.addClass('no-btns');
    return;
  }

  $widget.find('.text-section').append(`<div class="buttons-container">
      ${URL ? `<a href="${URL}" class="button" ${updateLinksAttributes(URL, 'Explore ' + Title)}>Explore</a>` : ''}
      ${PurchaseURL ? `<a href="${PurchaseURL}" class="button" ${updateLinksAttributes(PurchaseURL, 'Get Directions for ' + Title)}>Get Directions</a>` : ''}
      </div>`);
}
